import Constants from "./Constants";
import PortugueseStrings from "./PortugueseStrings";
import EnglishStrings from "./EnglishStrings";
import SpanishStrings from "./SpanishStrings";

const language = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);
const selectedStrings = language === Constants.EN_LANG_KEY
  ? EnglishStrings
  : language === Constants.ES_LANG_KEY
    ? SpanishStrings
    : PortugueseStrings;

// Fall back to Portuguese for text that has not yet received a
// language-specific translation.
export default Object.freeze({ ...PortugueseStrings, ...selectedStrings });
